import { SystemFeature, SystemSetting, SystemSettingType, ClientSystemSettingValueModel, ClientSystemSettingViewModel, ListItem } from "../../core/api/models";
import { ClientsApiService } from "../../core/api/services";
import { Utils } from "../../core/utils";
import { HttpClient, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { catchError, map, tap } from "rxjs/operators";
import { of } from "rxjs/internal/observable/of";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { error } from "jquery";
import { AutoCompleteCompleteEvent } from "primeng/autocomplete";
import { AlertService } from "../../shared/services/alert.service";

export class ClientSystemSettingEditModel {
  
  DefaultValue?: any | null;
  Description?: string | null;
  Required?: boolean;
  SettingName?: string | null;
  SettingOrder?: number;
  Settings?: any | null;
  ShowOnCompanySettings?: boolean;
  ShowOnEnterpriseSettings?: boolean;
  SystemFeature?: SystemFeature;
  SystemSetting?: SystemSetting;
  SystemSettingType?: SystemSettingType;



  Values?: Array<ClientSystemSettingValueModel> | null;
  currentValue?: ClientSystemSettingValueModel ;
  
  HasValue: boolean = false;


  saving = false;
  loading = false;

  ClientID?: number | null;
  CompanyID?: number | null;

  public Value?: string | null;
  public IntValue?: number | null;
  public BitValue?: boolean | null;
  public DateValue?: string | null;
  public TimeValue?: string | null;
  public DecimalValue?: number | null;

  /**
   * The base64 of the image thumbnail for the file setting. This is used to display a preview of the file in the UI.
   */
  ImageThumbnail?: string | null;


  SelectedListItem: ListItem | null = null;
  filteredListItems: ListItem[] = [];
  
  ShowTextInput: boolean = false;

  ShowNumberInput: boolean = false;

  ShowDateInput: boolean = false;

  ShowTimeInput: boolean = false;

  ShowSelectInput: boolean = false;

  ShowToggleInput: boolean = false;

  ShowTextAreaInput: boolean = false;

  ShowEditorInput: boolean = false;

  ShowFileInput: boolean = false;
  
  ShowAutoCompleteInput: boolean = false;


  get IsReferenceSystemSettingType(): boolean {
    return (!!this.SystemSettingType && this.SystemSettingType > 100);
  }


  constructor(
    clientID: number | null | undefined,
    private readonly clientsApiService: ClientsApiService,
    private readonly alertService: AlertService,
    clientSystemSetting: ClientSystemSettingViewModel) {
    // copy properties from ClientSystemSettingViewModel to ClientSystemSettingEditModel
      this.ClientID = clientID;
      this.Description = clientSystemSetting.Description;
      this.Required = clientSystemSetting.Required;
      this.SettingName = clientSystemSetting.SettingName;
      this.SettingOrder = clientSystemSetting.SettingOrder;
      this.Settings = clientSystemSetting.Settings;
      this.ShowOnCompanySettings = clientSystemSetting.ShowOnCompanySettings;
      this.ShowOnEnterpriseSettings = clientSystemSetting.ShowOnEnterpriseSettings;
      this.SystemFeature = clientSystemSetting.SystemFeature;
      this.SystemSetting = clientSystemSetting.SystemSetting;
      this.SystemSettingType = clientSystemSetting.SystemSettingType;
    
      this.DefaultValue = clientSystemSetting.DefaultValue;
      this.Values = clientSystemSetting.Values;

      if (clientSystemSetting.Values && clientSystemSetting.Values.length > 0) 
        this.setValue(clientSystemSetting.Values[0]);
      else
        this.setValue(undefined);
     
      if (this.SystemSettingType == SystemSettingType.Text
        || this.SystemSettingType == SystemSettingType.SecureText
        || this.SystemSettingType == SystemSettingType.Email
        || this.SystemSettingType == SystemSettingType.Password
        || this.SystemSettingType == SystemSettingType.Telephone
        || this.SystemSettingType == SystemSettingType.Url
        || this.SystemSettingType == SystemSettingType.Color) {
        this.ShowTextInput = true;
      } else if (this.SystemSettingType == SystemSettingType.PlainText
        || this.SystemSettingType == SystemSettingType.Markdown) {
        this.ShowTextAreaInput = true;
      } else if (this.SystemSettingType == SystemSettingType.HTML
        || this.SystemSettingType == SystemSettingType.RichText) {
        this.ShowEditorInput = true;
      } else if (this.SystemSettingType == SystemSettingType.Date) {
        this.ShowDateInput = true;
      } else if (this.SystemSettingType == SystemSettingType.Time) {
        this.ShowTimeInput = true;
      } else if (this.SystemSettingType == SystemSettingType.Datetime) {
        this.ShowDateInput = true;
        this.ShowTimeInput = true;
      } else if (this.SystemSettingType == SystemSettingType.Number
        || this.SystemSettingType == SystemSettingType.PercentageDecimal
        || this.SystemSettingType == SystemSettingType.PercentageInteger
        || this.SystemSettingType == SystemSettingType.Decimal
        || this.SystemSettingType == SystemSettingType.Currency) {
        this.ShowNumberInput = true;
      } else if (this.SystemSettingType == SystemSettingType.CheckBox) {
        this.ShowToggleInput = true;
      } else if (this.SystemSettingType == SystemSettingType.OneOption
        || this.SystemSettingType == SystemSettingType.MultipleOptions) {
        this.ShowSelectInput = true;
      } else if (this.SystemSettingType == SystemSettingType.Bytes
        || this.SystemSettingType == SystemSettingType.Image
        || this.SystemSettingType == SystemSettingType.File
        || this.SystemSettingType == SystemSettingType.Audio
        || this.SystemSettingType == SystemSettingType.Video

        || this.SystemSettingType == SystemSettingType.Photo) {
        this.ShowFileInput = true;
      } else if (this.IsReferenceSystemSettingType) {
        this.ShowAutoCompleteInput = true;
      } else {
        console.warn('Unexpected SystemSettingType: ' + this.SystemSettingType);
        this.ShowTextInput = true;
      }






  }



  
  setCompany(companyID: number| null | undefined): void {
      //console.debug('setCompany '+companyID)
      
      this.CompanyID  = companyID;
      this.setValue(this.Values?.find(value => value.CompanyID === companyID || (!companyID && !value.CompanyID)));
    
  }

  
  
  setValue(value: ClientSystemSettingValueModel|  undefined): void {
    
    this.currentValue  =value;
   if (value) {

      this.CompanyID  = value.CompanyID;
       this.Value = value.Value;
       this.IntValue = value.IntValue;
       this.DateValue = (value.DateValue) ? new Date(value.DateValue).toISOString().substring(0, 10): undefined;
       this.TimeValue = (value.DateValue) ? new Date(value.DateValue).toISOString().substring(11, 16): undefined;
     this.DecimalValue = value.DecimalValue;
     this.BitValue = value.BitValue;
     this.ImageThumbnail = value.ImageThumbnail;
      this.HasValue = true;

     if ((this.IsReferenceSystemSettingType || this.ShowAutoCompleteInput) && !!this.IntValue) {
       let listItem = {
         Value: this.IntValue,
         Text: this.Value ?? `${this.IntValue}`,
         Selected: true
       } as ListItem;
       //this.filteredListItems = [listItem];
       this.SelectedListItem = listItem;
       
     }


     if (this.SystemSettingType == SystemSettingType.Photo
       && !!this.IntValue
       && !this.ImageThumbnail)
     {
 
       this.clientsApiService.DownloadClientPhoto$Response({
         clientID: this.ClientID ?? 0,
         body: { photoID: this.IntValue }
       }).subscribe({next: async result => {

         let filename = this.Value ?? `photo_${this.IntValue}.jpg`;
           let disposition = result.headers.get('Content-Disposition');
           if (disposition && disposition.indexOf('attachment') !== -1) {
             var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
             var matches = filenameRegex.exec(disposition);
             if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
           }

         let type = result.headers.get('Content-Type') ?? 'application/octet-stream';
        
           let blob;
           if (typeof File === 'function') {
             try {
               blob = new File([result.body], filename, { type: type });
             } catch (e) { /* Edge */ }
           }
           if (typeof blob === 'undefined') {
           blob = new Blob([result.body], { type: type });
         }
         this.ImageThumbnail = `data:${type};base64,${Utils.arrayBufferToBase64(await blob.arrayBuffer())}`; 

       },
         error: error => {
           this.alertService.error('Error downloading the photo. ' + error);
           //this.alertService.error(Utils.getAjaxError(error));
         }
       });
     }

    } else {


     this.Value = undefined;
     this.IntValue = undefined;
     this.DateValue = undefined;
     this.TimeValue = undefined;
      this.DecimalValue = undefined;
      this.BitValue = undefined;
      this.HasValue = false;
    
      /*
      if (this.DefaultValue)
      {

        if (typeof this.DefaultValue === 'string') {
          this.Value = this.DefaultValue;
        } else if (typeof this.DefaultValue === 'number') {

          this.IntValue = this.DefaultValue;

        } else if (typeof this.DefaultValue === 'boolean') {
this.BitValue = this.DefaultValue;

        } else if (this.DefaultValue instanceof Date) {

          this.DateValue = this.DefaultValue;

        }
      }

      */


    }
    
  }

  
 getDefaultValue(): string | undefined
 {
    if (!this.DefaultValue)
        return undefined;


    if (this.SystemSettingType == SystemSettingType.Date) 
      return  new Date(this.DefaultValue).toDateString();

    if (this.SystemSettingType == SystemSettingType.CheckBox) 
      return  (this.DefaultValue)? 'Yes' : 'No';

    return this.DefaultValue.toString();
  }


  getRowCss(): string {

    if (this.ShowTextAreaInput) 
      return 'col-12 mb-2';


    return 'col-12 col-lg-6 col-xxl-4 mb-2';
  }

  getTextInputType(): string | undefined {

    if (this.SystemSettingType == SystemSettingType.Email)
      return 'email';
    if (this.SystemSettingType == SystemSettingType.Telephone)
      return 'tel';
    if (this.SystemSettingType == SystemSettingType.Url)
      return 'url';
    if (this.SystemSettingType == SystemSettingType.Color)
      return 'color';

    // let keep the typed password in plain text. the stored password is hidden.
    //if (this.SystemSettingType == SystemSettingType.Password)
    //  return 'password';

    return 'text';
  }
  getFileInputAcceptedValues(): string | undefined {

    if (this.SystemSettingType == SystemSettingType.Image
      || this.SystemSettingType == SystemSettingType.Photo)
      return 'image/*';
    if (this.SystemSettingType == SystemSettingType.Audio)
      return 'audio/*';
    if (this.SystemSettingType == SystemSettingType.Video)
      return 'video/*';

    return '*';
  }
  getPlaceholder(): string | undefined {

    if (this.SystemSettingType == SystemSettingType.Password) {
      if (this.HasValue && this.BitValue == true)
        return 'XXXXXX (Secret)';
    }
    if (this.SystemSettingType == SystemSettingType.Bytes) {
      if (this.HasValue && this.IntValue != null)
        return Utils.formatByteSize(this.IntValue);
    }

    if (this.ShowFileInput && !!this.Value) {
      return this.Value;
      
    }

    if (this.SystemSettingType == SystemSettingType.Currency)
      return '0.00';


    return '';
  }

  getOptions(): any| undefined {

    return [];
  }

  getListItems(event: AutoCompleteCompleteEvent) {
    
    let query = event.query;
    if (query.indexOf('[') > 0)
      query = query.substring(0, query.indexOf('[')).trim();
    if (query.indexOf(' - ') > 0)
      query = query.substring(0, query.indexOf(' - ')).trim();

    let customSource = (this.Settings && this.Settings.Source) ? this.Settings.Source : null;

    this.loading = true;

    this.clientsApiService.GetClientFormOptions({
      clientID: this.ClientID || 0,
      body: {
        prefixText: query,
        count: 100,
        systemSettingTypeID: this.SystemSettingType || 0,
        customSource: customSource
      }
    })
      .forEach((result) => {

        this.loading = false;
        this.filteredListItems = result;
      }).catch(
        err => {
          this.loading = false;
          this.alertService.error(Utils.getAjaxError(err));
        });

  }


  save(): void {

    if (this.ShowFileInput) {
      // trigger file upload dialog #fileInput
      const fileInput = document.getElementById(`setting_${this.SystemSetting}`) as HTMLInputElement;
      if (fileInput) {
        fileInput.click();
      }
      return;

    }

    if (this.saving)
      return;

    this.saving = true;
    let data = {

      SystemSetting: this.SystemSetting,
      CompanyID: this.CompanyID,
      Value: this.Value,
      IntValue: this.IntValue,
      DateValue: (this.ShowTimeInput) ? this.DateValue + ' ' + this.TimeValue : this.DateValue,
      DecimalValue: this.DecimalValue,
      BitValue: this.BitValue,

    };
    this.clientsApiService.SaveClientSystemSetting({
      clientID: this.ClientID || 0, body: data
    }).pipe(
      catchError((error: HttpErrorResponse) => {
        this.alertService.error(Utils.getAjaxError(error));
        return of(undefined);
      })
    ).subscribe((result) => {
      if (result) {
        // this.currentFeatureStatus = result;
        if (!!this.currentValue) {
          this.currentValue.Value = data.Value;
          this.currentValue.IntValue = data.IntValue;
          this.currentValue.DateValue = data.DateValue;
          this.currentValue.DecimalValue = data.DecimalValue;
          this.currentValue.BitValue = data.BitValue;
        } else {
          this.currentValue = data as ClientSystemSettingValueModel;
        }
      }
      this.saving = false;
    });
  }

  upload(target: EventTarget  | null): void {
    if (this.saving || !target)
      return;

    const input = target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) {
      input.value = '';
      this.alertService.error('Select a file to upload.');
      return;
    }
    if (file.size === 0 || file.size > 50 * 1024 * 1024) {
      input.value = '';
      this.alertService.error('Select a non-empty file of at most 50 MB.');
      return;
    }

    this.saving = true;
    this.clientsApiService.UploadClientSystemSetting({
      clientID: this.ClientID || 0,
      body: { systemSettingID: this.SystemSetting, companyID: this.CompanyID ?? undefined, file }
    }).subscribe({
      next: () => {
        this.saving = false;
        //this.alertService.success(this.SettingName + ' uploaded successfully.');

        this.Value = file.name;
        if (this.SystemSettingType == SystemSettingType.Image
          || this.SystemSettingType == SystemSettingType.Photo
          || file.type.startsWith('image/')) {
          // update image thumbnail
          const reader = new FileReader();
          reader.onload = (e) => {
            var data =  e.target?.result as ArrayBuffer;
            if (data)
              this.ImageThumbnail = `data:${file.type};base64,${Utils.arrayBufferToBase64(data)}`; 
          };
          reader.readAsArrayBuffer(file);
        }

        if (!!this.currentValue) {
          this.currentValue.Value =  file.name;
          
        } else {
          this.currentValue = {
            Value: file.name,
            CompanyID: this.CompanyID,
          } as ClientSystemSettingValueModel;
        }

      },
      error: error => {
        this.saving = false;
        this.alertService.error(Utils.getAjaxError(error));
      }
    });
  }



}

